import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import { Provider } from "./components/ui/provider.tsx";
import { Layout } from "./utils/layout/layout.tsx";
import { MainPage } from "./pages/main-page.tsx";
import AppRoute from "./utils/route/app.route.tsx";
import { SingePage } from "./pages/singe-page.tsx";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: Infinity },
  },
});

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path={"/"}
          element={
            <AppRoute>
              <Layout />
            </AppRoute>
          }
        >
          <Route index element={<MainPage />} />
          <Route path={"/:id"} element={<SingePage />} />
        </Route>
      </>,
    ),
  );

  return (
    <Suspense fallback={<></>}>
      <QueryClientProvider client={queryClient}>
        <Provider>
          <RouterProvider router={router} />
        </Provider>
      </QueryClientProvider>
    </Suspense>
  );
}

export default App;
